import React, { useState } from 'react';
import { useNewsletterApi } from '../../hooks/useNewsletterApi';
import Ink from 'react-ink';
import { showToast } from './Toast';

const NewsletterSignUp = ({ bgColor = '#1C2938' }) => {
  const [email, setEmail] = useState('');
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const { submitNewsletter, loading } = useNewsletterApi();

  // Step 2: Update state on change
  const handleChange = (e) => {
    // if valid email, enable button
    if (e.target.value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
    setEmail(e.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!email) {
      const errorMessage = 'Please enter an email address.';
      showToast(errorMessage, 'error');
      return
    }

    setButtonDisabled(true);

    // /api/v5/sailthru/reoptin
    const response = await submitNewsletter({ email });
    console.log(response)

    if (response.success) {
      showToast('Thank you for subscribing!', 'success');
      setEmail('')
      // trackEvents(response, { email });
    } else {
      setButtonDisabled(false);
      showToast(response.message, 'error');
    }
  };

  return (
      <div className="flex flex-col lg:flex-row lg:gap-8 lg:justify-between border-t border-[#FFF] border-opacity-20">
        <div className="text-left pt-8 lg:py-8 pl-[5%] lg:pl-0 lg:w-1/2">
          <h5 className="text-white text-xl font-semibold mb-2">
            Newsletter
          </h5>
          <p className="mb-2 text-lg leading-8">
            Sign up for our mailing list to get the latest updates and offers.&nbsp;
          </p>
        </div>
        <div className="flex-grow align-center text-left pb-8 pt-2 lg:py-8 lg:w-1/2 lg:max-w-[514px]">
          <div className="flex flex-grow h-full items-center">
            <form
              onSubmit={(e) => handleSubmit(e)}
              className="flex align-center py-[10px] px-[16px] pl-5 bg-white shadow-lg rounded-full w-full"
            >
              <input
                id="emailAddress"
                type="email"
                placeholder="Enter your email"
                className="
                  flex-1 overflow-ellipsis overflow-hidden md:text-lg font-normal text-[#231F20]
                  placeholder:text-[#231F20] focus:outline-none rounded-full pl-1
                "
                value={email}
                onChange={handleChange}
                style={{
                  // Target WebKit browsers to override autofill styles
                  WebkitBoxShadow: '0 0 0px 1000px white inset',
                  transition: 'background-color 5000s ease-in-out 0s',
                }}
              />

              <button
                type="submit"
                className="
                  ml-1 relative flex-none w-12 h-12 text-white font-medium text-lg rounded-full bg-[#4FAB55]
                "
                // disabled={buttonDisabled}
              >
                &gt;{<Ink />}
              </button>
            </form>
          </div>
        </div>
      </div>
  );
};

export default NewsletterSignUp;
